import React from 'react';
import PropTypes from 'prop-types';
import { formats } from 'utils';

import { Typography, Link, Tooltip } from '../../../alf-design';
import ClaimField from './ClaimField';

const ClaimInformation = ({ index, claim }) => {
  const isOpen = claim?.claimStatus !== 'Closed';
  const examinerPhone = claim?.claimsExaminer?.phone;
  const examinerEmail = claim?.claimsExaminer?.email;

  return (
    <div className="bg-legacy-bgLight rounded-[10px] p-[16px]">
      <div className="grid grid-cols-3 mb-[16px]">
        <ClaimField
          label="Claim Number"
          id={`claimNumber-${index}`}
          value={claim?.claimNumber}
        />
        <ClaimField
          label="Claim Status"
          id={`claimStatus-${index}`}
          value={claim?.claimStatus}
        />
        <ClaimField
          label="Date of Loss"
          id={`claimLossDate-${index}`}
          value={formats.dateFormat(claim?.loss?.date)}
        />
      </div>
      <div className="grid grid-cols-3">
        <ClaimField
          label="Date Filed"
          id={`claimFiledDate-${index}`}
          value={formats.dateFormat(claim?.claimFiledDate)}
        />
        {claim?.isFusion ? (
          <>
            <ClaimField
              label="Policy Number"
              id={`claimFiledDate-${index}`}
              value={claim?.policyNumber}
            />
            <ClaimField
              label="Product"
              id={`claimFiledDate-${index}`}
              value={claim?.type}
            />
          </>
        ) : (
          <>
            <ClaimField label="Claims Adjuster Phone">
              {examinerPhone && isOpen ? (
                <Typography type="caption2" className="text-legacy-textDark">
                  <a
                    data-testid={`examinerPhone-${index}`}
                    href={`tel:${examinerPhone}`}
                    className="text-legacy-primary text-decoration-none text-[14px]"
                    tabIndex="0"
                  >
                    {formats.phoneFormat(examinerPhone)}
                  </a>
                </Typography>
              ) : (
                <Typography type="caption2" className="text-legacy-primary">
                  <a
                    data-testid={`examinerPhone-${index}`}
                    href={`tel:800-230-3758`}
                    className="link"
                    tabIndex="0"
                  >
                    (800) 230-3758
                  </a>
                </Typography>
              )}
            </ClaimField>
            <div>
              <Typography type="footer" component="div">
                Claims Adjuster Email
                <Tooltip
                  ariaLabel="Claim Adjuster Email Tooltip"
                  text={
                    <>
                      For <strong>existing</strong> claims only. Not for
                      reporting new claims. The email subject line{' '}
                      <strong>must</strong> include the claim number.
                    </>
                  }
                  dataFor="claimEmail"
                />
              </Typography>
              {claim?.claimsExaminer?.email &&
              claim?.claimStatus !== 'Closed' ? (
                <Link
                  type="primary"
                  data-testid={`examinerEmail-${index}`}
                  href={`mailto:${examinerEmail}?subject=Claim #${claim?.claimNumber}`}
                  email
                >
                  {examinerEmail}
                </Link>
              ) : (
                <Link
                  type="primary"
                  data-testid={`examinerEmail-${index}`}
                  href={`mailto:claims@slideinsurance.com?subject=Claim #${claim?.claimNumber}`}
                  email
                >
                  claims@slideinsurance.com
                </Link>
              )}
            </div>
          </>
        )}
      </div>
      {claim?.isFusion && (
        <div className="grid grid-cols-3 mt-[16px]">
          <ClaimField label="Claims Adjuster Phone">
            {examinerPhone && isOpen ? (
              <Typography type="caption2" className="text-legacy-textDark">
                <a
                  data-testid={`examinerPhone-${index}`}
                  href={`tel:${examinerPhone}`}
                  className="text-legacy-primary text-decoration-none text-[14px]"
                  tabIndex="0"
                >
                  {formats.phoneFormat(examinerPhone)}
                </a>
              </Typography>
            ) : (
              <Typography type="caption2" className="text-legacy-primary">
                <a
                  data-testid={`examinerPhone-${index}`}
                  href={`tel:800-230-3758`}
                  className="link"
                  tabIndex="0"
                >
                  (800) 230-3758
                </a>
              </Typography>
            )}
          </ClaimField>
          <div>
            <Typography type="footer" component="div">
              Claims Adjuster Email
              <Tooltip
                ariaLabel="Claim Adjuster Email Tooltip"
                text={
                  <>
                    For <strong>existing</strong> claims only. Not for reporting
                    new claims. The email subject line <strong>must</strong>{' '}
                    include the claim number.
                  </>
                }
                dataFor="claimEmail"
              />
            </Typography>
            {claim?.claimsExaminer?.email && claim?.claimStatus !== 'Closed' ? (
              <Link
                type="primary"
                data-testid={`examinerEmail-${index}`}
                href={`mailto:${examinerEmail}?subject=Claim #${claim?.claimNumber}`}
                email
              >
                {examinerEmail}
              </Link>
            ) : (
              <Link
                type="primary"
                data-testid={`examinerEmail-${index}`}
                href={`mailto:claims@slideinsurance.com?subject=Claim #${claim?.claimNumber}`}
                email
              >
                claims@slideinsurance.com
              </Link>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

ClaimInformation.propTypes = {
  index: PropTypes.number,
  claim: PropTypes.object,
};

export default ClaimInformation;
